import { render, staticRenderFns } from "./IndexReception.vue?vue&type=template&id=e2590c0a&"
import script from "./IndexReception.vue?vue&type=script&lang=js&"
export * from "./IndexReception.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\dev.marcdeloche.fr\\themes\\marcdeloche\\_dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('e2590c0a', component.options)
    } else {
      api.reload('e2590c0a', component.options)
    }
    module.hot.accept("./IndexReception.vue?vue&type=template&id=e2590c0a&", function () {
      api.rerender('e2590c0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/vuejs/components/Giftcard/IndexReception.vue"
export default component.exports